'use client';

import React from 'react';
import Link from 'next/link';
import { twJoin } from 'tailwind-merge';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import { useLocaleLink } from '@/ui/hooks/useLocaleLink';
import { LogobarTile } from './types/LogobarTile';
import OptimizedImage from '../../shared/OptimizedImage';
import Container from '../../shared/Container';

export default function Logobar({ tile }: { tile: LogobarTile }) {
  const { localizedLink } = useLocaleLink();
  const removeBottomMargin = tile['remove-bottom-margin']?.value;
  const removeTopMargin = tile['remove-top-margin']?.value;
  const links = tile.links?.chunks;

  return (
    <Container
      className={twJoin(
        removeBottomMargin && 'mb-0 sm:mb-0 lg:mb-0',
        removeTopMargin && 'mt-0 sm:mt-0 lg:mt-0',
      )}
    >
      <div className=" mx-auto flex max-w-3xl flex-wrap justify-center gap-x-3 gap-y-3 sm:gap-y-6">
        {tile.logos?.images?.map((logo, idx) => {
          if (links?.length > 0 && links?.[idx]) {
            const externalLink = extractComponentFromChunk(
              links[idx],
              'link',
              'SingleLineContent',
            )?.text;
            const internalLink = extractComponentFromChunk(
              links[idx],
              'internal-link',
              'ItemRelationsContent',
            )?.items?.[0]?.path;
            const dontOpenLinkInNewTab = extractComponentFromChunk(
              links[idx],
              'dont-open-link-in-new-tab',
              'BooleanContent',
            )?.value;

            const href = internalLink ? localizedLink(internalLink) : externalLink;

            return (
              <Link
                key={logo.key}
                href={href || '/'}
                target={dontOpenLinkInNewTab ? '_self' : '_blank'}
                rel="noreferrer"
                aria-label={logo.altText || ''}
              >
                <OptimizedImage
                  image={logo}
                  width={150}
                  height={50}
                  className=" h-12 w-auto"
                  sizes="300px"
                />
              </Link>
            );
          }
          return (
            <OptimizedImage
              key={logo.key}
              image={logo}
              width={150}
              height={50}
              className=" h-12 w-auto"
              sizes="300px"
            />
          );
        })}
      </div>
    </Container>
  );
}
